module.exports = function getResource(label, vars = []) {
    const resources = {
        nameError: 'Veuillez remplir ce champ.',
        name: 'Nom',
        edit: 'Modifier',
        firstNameLabel: 'Prénom',
        lastNameLabel: 'Nom de famille',
        cancel: 'Annuler',
        update: 'Mise à jour'
    };
    return resources[label];
};
